import { useState } from 'react'
import { InputDinamycPlaceholder, TextareaDynamicPlaceholder } from "@lk-gtcom/ecomlab-components"
import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { ModalComponent } from '../../Modal/ModalComponent/ModalComponent';
import './ModalEditDynamicFormComponent.scss'

export const ModalNewTaskList = ({
    setIsModal,
    current = {},
    fetchChange = false
}) => {
    const [name, setName] = useState(current?.front_name || '')
    const [dict, setDict] = useState(current?.possible_values)
    const [isEditDict, setIsEditDict] = useState(false)

    return (
        <ModalComponent
            title='Изменить поле'
            onClose={e => setIsModal(false)}
            style={{
                height: 'auto',
                maxWidth: '500px'
            }}
            child={
            <div className='modal-edit-dynamic-form-component'>

                <InputDinamycPlaceholder
                    placeholder='Название'
                    type='text'
                    changeValue={name}
                    onChange={e => setName(e)}
                    autoFocus
                />

                {isEditDict && <TextareaDynamicPlaceholder
                    changeValue={dict}
                    width={'100%'}
                    placeholder="Введите значения списка через Enter"
                    onChange={(e) => setDict(e)}
                    returnArr
                />}

                <div className='modal-edit-dynamic-form-component__btn-group'>
                    <ButtonBasic
                        blue
                        width='calc(50% - 6px)'
                        text='Настроить список'
                        disabled={current?.data_type !== 'dict'}
                        onClick={(e) => setIsEditDict(true)}
                    />

                    <ButtonBasic
                        green
                        width='calc(50% - 6px)'
                        text='Применить'
                        onClick={() => {
                            setIsModal(false)
                            fetchChange(name, current?.id, current?.data_type, current?.before, dict)
                        }}
                    />
                </div>
            </div>}
        />
    )
}